<template>
  <form
    class="new-payroll"
    @submit.prevent="create"
  >
    <div class="columns is-multiline">
      <div class="column is-6">
        <PayrollDetails
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-6">
        <PayrollReceiver
          :loading="loading"
          :disabled="loading"
        />
      </div>
      <div class="column is-12">
        <PayrollPercepts
          :loading="loading"
          :disabled="loading"
        />
      </div>
    </div>
    <div
      v-observe-visibility="onTotalsVisibleChange"
      class="action-buttons is-flex"
    >
      <div
        class="box totals wrapper-salary-receipt-totals"
        :class="{ 'totals-is-not-visible has-background-info': !totalsIsVisible }"
      >
        <div>
          <div
            :class="[totalsIsVisible ? 'is-7' : 'is-narrow']"
          >
            <h4
              class="title is-5"
              :class="[totalsIsVisible ? 'has-text-primary' : 'has-text-white']"
            >
              Total: {{ $store.getters['payroll/total'] | toCurrency }}
            </h4>
          </div>
        </div>
      </div>
      <div class="field is-grouped">
        <p class="control">
          <button
            class="button is-success"
            :class="{ 'is-loading': loading }"
            type="submit"
            :disabled="loading"
          >
            Generar Recibo de Salario
          </button>
        </p>
        <p class="control">
          <RouterLink
            class="button is-danger"
            :class="{ 'is-loading': loading }"
            :disabled="loading"
            :to="{ name: 'Home' }"
          >
            Cancelar
          </RouterLink>
        </p>
      </div>
    </div>
    <RouterView />
  </form>
</template>

<script>
export default {
  name: 'NewSalaryReceipt',
  components: {
    PayrollDetails: () => import(/* webpackChunkName: "salary-receipt-detail" */ '@/components/Admin/Payroll/SalaryReceiptDetail.vue'),
    PayrollReceiver: () => import(/* webpackChunkName: "payroll-basic-receiver" */ '@/components/Admin/Payroll/PayrollBasicReceiver.vue'),
    PayrollPercepts: () => import(/* webpackChunkName: "salary-receipt-percepts" */ '@/components/Admin/Payroll/SalaryReceiptPercepts.vue'),
  },
  data() {
    return {
      loading: false,
      totalsIsVisible: false,
    };
  },

  async beforeDestroy() {
    window.location.reload();
  },
  methods: {
    async create() {
      if (!this.$store.state.employee.id) {
        this.$warning({
          message: 'Necesitas seleccionar un empleado',
        });
      }

      this.loading = true;
      try {
        await this.$store.dispatch('payroll/createSalaryReceipt');
        this.$router.push({ name: 'SalaryReceiptList' });
        this.$success({ message: 'Recibo de salario creado con éxito' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
    onTotalsVisibleChange(isVisible) {
      this.totalsIsVisible = isVisible;
    },
  },
};
</script>

<style scoped>
.action-buttons {
  flex-direction: column;
  align-items: flex-end;
}

.new-payroll {
  padding: 1rem;
  margin-bottom: 6rem;
}

.totals {
  padding: 1.5rem;
}

.totals:not(.totals-is-not-visible) {
  padding: 2rem;
}

.totals .column:not(:last-child) {
  padding: 0 0 .5rem 0;
}

.totals .column:nth-last-child(2),
.totals .column:last-child {
  padding: 0;
}

.totals-is-not-visible {
  bottom: 4px;
  overflow: hidden;
  position: fixed;
  right: 95px;
  z-index: 2;
}

.totals.totals-is-not-visible .column {
  padding: 0 1rem 0 0;
}
</style>
